export default __webpack_public_path__ + "img/39271481933052d369d9df263a6972c7.svg";